import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import AccessRequestsTab from '../components/admin/AccessRequestsTab';
import ModerateVisitsTab from '../components/admin/ModerateVisitsTab';
import CreateStoneTab from '../components/admin/CreateStoneTab';
import './AdminPanel.css';

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('requests');
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAdminAccess();
  }, []);

  const checkAdminAccess = async () => {
    try {
      const session = await fetchAuthSession();
      const groups = session.tokens?.accessToken?.payload['cognito:groups'] || [];
      
      if (groups.includes('admin') || groups.includes('family')) {
        setIsAdmin(true);
      } else {
        navigate('/app');
      }
    } catch (error) {
      console.error('Error checking admin access:', error);
      navigate('/app');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="admin-loading">Checking permissions...</div>;
  }

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="admin-panel">
      <header className="admin-header">
        <h1>Admin Panel</h1>
        <button onClick={() => navigate('/app')} className="back-button">
          ← Back to Map
        </button>
      </header>
      
      <div className="admin-tabs">
        <button
          className={`tab ${activeTab === 'requests' ? 'active' : ''}`}
          onClick={() => setActiveTab('requests')}
        >
          Access Requests
        </button>
        <button
          className={`tab ${activeTab === 'moderate' ? 'active' : ''}`}
          onClick={() => setActiveTab('moderate')}
        >
          Moderate Visits
        </button>
        <button
          className={`tab ${activeTab === 'stones' ? 'active' : ''}`}
          onClick={() => setActiveTab('stones')}
        >
          Add Stone
        </button>
      </div>
      
      <div className="admin-content">
        {activeTab === 'requests' && <AccessRequestsTab />}
        {activeTab === 'moderate' && <ModerateVisitsTab />}
        {activeTab === 'stones' && <CreateStoneTab />}
      </div>
    </div>
  );
};

export default AdminPanel;